import { type SanityTeamMember } from '@data/sanity/queries/types/blocks'

import TeamMemberCard from '@blocks/team-member-card'

interface TeamMembersGridProps {
  title?: string
  subtitle?: string
  teamMembers?: SanityTeamMember[]
}

const TeamMembersGrid = ({
  title,
  subtitle,
  teamMembers,
}: TeamMembersGridProps) => {
  return (
    <section className="bg-gray-light text-green-dark">
      <div className="relative container py-12 sm:py-16 md:py-24 lg:py-32">
        {subtitle && <p>{subtitle}</p>}
        {title && <h3>{title}</h3>}

        {teamMembers && teamMembers.length > 0 && (
          <div className="mt-8 lg:mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-8 sm:gap-x-8 lg:gap-x-12 lg:gap-y-12">
            {teamMembers
              .filter((teamMember) => teamMember)
              .map((teamMember, index) => (
                <TeamMemberCard
                  key={`team-members-grid-${index}-${teamMember.slug}`}
                  teamMember={teamMember}
                />
              ))}
          </div>
        )}
      </div>
    </section>
  )
}

export default TeamMembersGrid
